import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { geti18n } from '../../../utils';
import { getTermFromState } from '../../../redux/selectors/i18n'
import { getModelLines, getActiveModelLineTrims, getActiveModelLineYear, getActiveModelLineName } from '../../../redux/selectors/models';
import { getActiveTrimName, getActiveTrimNCode } from '../../../redux/selectors/trim';
import { shouldRenderInlineTrimSelector } from '../../../redux/selectors/userAmounts';
import { trimSelectedAction } from '../../../redux/actions/trim';
import { openTrimModelChooserAction, closeTrimModelChooserAction } from '../../../redux/actions/modelTrimChooser';
import { modelLineSelectedAction } from '../../../redux/actions/modelline';
import { initialRenderReset, resetTermMileage } from '../../../redux/actions/bestOffers';
import { getURLTrimName, isConstructedTrim, isRangePage, getVendorParam } from '../../../redux/selectors/helios';
import Location from '../../../components/Location';
import SelectBox from '../../../components/SelectBox';

// Stylesheets
import './styles';

/**
 * Once a user has selected a Model Line they then must Select
 * a trim which will have an associated NCode wit hit. The
 * NCode is required for the call to recieve the best offers
 */
class TrimSelector extends Component {
  static propTypes = {
    selectTrim: PropTypes.func.isRequired,
    selectModel: PropTypes.func.isRequired,
    openChooser: PropTypes.func.isRequired,
    closeChooser: PropTypes.func.isRequired,
    editLinkText: PropTypes.string.isRequired,
    doneLinkText: PropTypes.string.isRequired,
    modelName: PropTypes.string,
    models: PropTypes.array,
    trims: PropTypes.array,
    year: PropTypes.string,
    trimName: PropTypes.string,
    nCode: PropTypes.string,
    modelLineCode: PropTypes.string,
    renderInlineTrimSelector: PropTypes.bool,
    modelTrimOpen: PropTypes.bool.isRequired,
    trimSelectorText: PropTypes.string,
    modelSelectorText: PropTypes.string,
    brand: PropTypes.string.isRequired,
    initialReset: PropTypes.func.isRequired,
    resetOffers: PropTypes.func.isRequired,
    trimNameFromURL: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    boolConstructedTrim: PropTypes.bool.isRequired,
    fromRangePage: PropTypes.bool.isRequired,
    vendor: PropTypes.string.isRequired
  };
  static defaultProps = {
    models: undefined,
    trims: undefined,
    year: undefined,
    modelName: undefined,
    trimName: undefined,
    nCode: undefined,
    renderInlineTrimSelector: undefined,
    modelLineCode: undefined,
    modelTrimOpen: undefined,
    trimSelectorText: geti18n('trimSelectPanel.trimSelectDefault'),
    modelSelectorText: geti18n('trimSelectPanel.modelSelectDefault')
  };
  constructor() {
    super();
    this.onOpenChooser = this.onOpenChooser.bind(this);
    this.onCloseChooser = this.onCloseChooser.bind(this);
    this.onSelectTrim = this.onSelectTrim.bind(this);
    this.onSelectModel = this.onSelectModel.bind(this);
  }
  onOpenChooser() {
    const { openChooser } = this.props;
    openChooser();
  }
  onCloseChooser() {
    const { closeChooser } = this.props;
    closeChooser();
  }
  onSelectModel(modelLineCode) {
    const { selectModel } = this.props;
    selectModel(modelLineCode, 'DROPDOWN-BOX');
  }
  onSelectTrim(nCode) {
    const { selectTrim, initialReset, resetOffers } = this.props; //eslint-disable-line
    selectTrim(nCode, 'DROPDOWN-BOX');
    initialReset();
  }
  renderTrimSelector(isInline = false) {
    const { trims, nCode, trimSelectorText, renderInlineTrimSelector } = this.props;
    if (trims && (!isInline || (isInline && renderInlineTrimSelector))) {
      return (
        <span className="select-trim">
          <SelectBox label={trimSelectorText} items={trims} value={nCode} textKey="trimName" valueKey="nCode" onSelect={this.onSelectTrim} />
        </span>);
    }
    return undefined;
  }
  renderModelSelector() {
    const { models, modelSelectorText, modelLineCode } = this.props;
    models.sort((a, b) => {
      const x = a.modelLineFullName;
      const y = b.modelLineFullName;
      const z = x > y ? 1 : 0;
      return x < y ? -1 : z;
    });
    return models ?
      (
        <SelectBox label={modelSelectorText} items={models} value={modelLineCode} textKey="tradeMarkName" valueKey="modelLineCode" onSelect={this.onSelectModel} />
      ) : undefined;
  }
  renderEditButton() {
    const { modelTrimOpen } = this.props;

    return (<div className="column trim-select-edit" aria-hidden={!modelTrimOpen}>
      <div className="row">
        <div className="large-3 medium-6 small-12 columns">
          {this.renderModelSelector()}
        </div>
        <div className="large-3 medium-6 small-12 columns end">
          {this.renderTrimSelector()}
        </div>
      </div>
    </div>);
  }
  render() {
    const {
      year,
      modelName,
      trimName,
      editLinkText,
      doneLinkText,
      modelTrimOpen,
      boolConstructedTrim,
      trimNameFromURL,
      fromRangePage,
      vendor
    } = this.props;
    /**
     * Infiniti Vehicles include the model name in the trim name
     * So, if the trimName is defined, we don't want to display the modelName
     */
    const modelTitle = (this.props.brand === 'in' && trimName) ? undefined : <span dangerouslySetInnerHTML={{ __html: modelName }} />;
    const editButton = fromRangePage || vendor === 'nna' ? this.renderEditButton() : '';
    const openChooser = fromRangePage || vendor === 'nna' ? <a onClick={this.onOpenChooser} className="open-chooser" aria-hidden={modelTrimOpen}>{editLinkText}</a> : '';
    const closeChooser = fromRangePage || vendor === 'nna' ? <a onClick={this.onCloseChooser} className="close-chooser" aria-hidden={!modelTrimOpen}>{doneLinkText}</a> : '';
    const trimTitle = boolConstructedTrim && !trimName ?
      <span className="bold select-title">{trimNameFromURL} {closeChooser} {openChooser} </span> :
      <span className="bold select-title"> {modelTitle} <span> {trimName} </span> {closeChooser} {openChooser} </span>;

    return (
      <div className="row margin-bottom-small">
        <div className="columns large-12 trim-selector">
          <form>
            <div className="trim-panel row">
              <div className="large-12 medium-12 column">
                <div className="selected-model-trim">
                  <span className="select-year">{year}</span>{trimTitle} <Location disabled={false} />{this.renderTrimSelector(true)}
                </div>
              </div>
              {editButton}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  models: getModelLines(state),
  trims: getActiveModelLineTrims(state),
  year: getActiveModelLineYear(state),
  modelName: getActiveModelLineName(state),
  editLinkText: getTermFromState(state, 'trimSelectPanel.editLink'),
  doneLinkText: getTermFromState(state, 'trimSelectPanel.doneLink'),
  trimName: getActiveTrimName(state),
  nCode: getActiveTrimNCode(state),
  renderInlineTrimSelector: shouldRenderInlineTrimSelector(state),
  modelLineCode: state.navigation.modelLineCode,
  modelTrimOpen: state.userAmounts.modelTrimSelectorOpen,
  brand: state.environment.BRAND_CHANNEL,
  trimNameFromURL: getURLTrimName(state),
  boolConstructedTrim: isConstructedTrim(state),
  fromRangePage: isRangePage(state),
  vendor: getVendorParam(state)
});

const mapDispatchToProps = dispatch => ({
  selectTrim: bindActionCreators(trimSelectedAction, dispatch),
  selectModel: bindActionCreators(modelLineSelectedAction, dispatch),
  openChooser: bindActionCreators(openTrimModelChooserAction, dispatch),
  closeChooser: bindActionCreators(closeTrimModelChooserAction, dispatch),
  initialReset: bindActionCreators(initialRenderReset, dispatch),
  resetOffers: bindActionCreators(resetTermMileage, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrimSelector);




/** WEBPACK FOOTER **
 ** ./src/pages/ModelView/TrimSelector/index.js
 **/